import { render, staticRenderFns } from "./typeOfWork.vue?vue&type=template&id=804949d6"
import script from "./typeOfWork.vue?vue&type=script&lang=js"
export * from "./typeOfWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports